/* unplugin-vue-components disabled */import { render } from "./LeftBox.vue?vue&type=template&id=32946d8e&scoped=true"
import script from "./LeftBox.vue?vue&type=script&lang=js"
export * from "./LeftBox.vue?vue&type=script&lang=js"

import "./LeftBox.vue?vue&type=style&index=0&id=32946d8e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32946d8e"]])

export default __exports__